
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ieTY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraAutomationSettingsPage", () => $feb07078eedc1738$export$9f0de1aaf472742a);
$parcel$export(module.exports, "default", () => $feb07078eedc1738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("2Geeh");

var $47bDC = parcelRequire("47bDC");

var $i2Rm5 = parcelRequire("i2Rm5");

var $dAfqg = parcelRequire("dAfqg");

var $OxJd1 = parcelRequire("OxJd1");

var $9OXo1 = parcelRequire("9OXo1");

var $1bQGJ = parcelRequire("1bQGJ");

var $5Ix9D = parcelRequire("5Ix9D");
const $feb07078eedc1738$var$METRICS_PAGE_ID = 'project-settings-apps.jira-automation'; // eslint-disable-next-line jira/react/no-class-components
class $feb07078eedc1738$export$9f0de1aaf472742a extends (0, $5uXOq.Component) {
    render() {
        const { projectKey: projectKey } = this.props.match.params;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $OxJd1.ProjectSettingsController), {
            projectKey: projectKey
        }, this.renderContents());
    }
    constructor(...args){
        super(...args), this.renderContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
                id: $feb07078eedc1738$var$METRICS_PAGE_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
                        theme: {}
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ix9D.default), {
                        tenantContext: tenantContext,
                        projectContext: projectContext.data
                    }))))));
    }
}
var $feb07078eedc1738$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($feb07078eedc1738$export$9f0de1aaf472742a);

});
parcelRegister("OxJd1", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $3be22f45e427033f$export$9e38610dc1164d7d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $9QpK7 = parcelRequire("9QpK7");

var $cSD7y = parcelRequire("cSD7y");

var $3mYHL = parcelRequire("3mYHL");

var $9NiTW = parcelRequire("9NiTW");

var $9OXo1 = parcelRequire("9OXo1");

var $7tQej = parcelRequire("7tQej");

var $lADEy = parcelRequire("lADEy");
const $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $3be22f45e427033f$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $3be22f45e427033f$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $3be22f45e427033f$export$9e38610dc1164d7d = (0, $cSD7y.componentWithFG)('projectsettingscontroller_error_boundary', $3be22f45e427033f$export$6d6f90026f9508a7, $3be22f45e427033f$export$2164d5fb3f070c32);
const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lADEy.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lADEy.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects = (0, $9QpK7.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsNew, $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsOld);

});
parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("lADEy", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $3bad71e90d481a39$export$b6f3f3997ca8a783);

var $dxCvy = parcelRequire("dxCvy");

var $2YP9W = parcelRequire("2YP9W");
const $3bad71e90d481a39$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("5Ix9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $2666825ce409db17$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $9Shla = parcelRequire("9Shla");
var $2666825ce409db17$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $9Shla.default));

});
parcelRegister("9Shla", function(module, exports) {

$parcel$export(module.exports, "default", () => $234eb071001a473c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $drk9v = parcelRequire("drk9v");

var $c2D8L = parcelRequire("c2D8L");

var $kb4zh = parcelRequire("kb4zh");

var $Uj4ce = parcelRequire("Uj4ce");

var $63MBm = parcelRequire("63MBm");

var $huDMB = parcelRequire("huDMB");
const $234eb071001a473c$var$JiraAutomationAppWrapper = ({ tenantContext: tenantContext, projectContext: projectContext, intl: { formatMessage: formatMessage } })=>{
    const { enabled: isLegacyAutomationEnabled } = (0, $Uj4ce.useNavigationAutomationLegacyEnabledResource)().data || {};
    if (!projectContext || !tenantContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    const { projectId: projectId, projectKey: projectKey, projectType: projectType } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $63MBm.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKey,
        gridLayout: "fluid"
    }, isLegacyAutomationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $huDMB.default).breadcrumb)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drk9v.default), {
        container: {
            id: projectId,
            key: projectKey,
            type: projectType
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drk9v.default), {
        container: {
            id: projectId,
            key: projectKey,
            type: projectType
        }
    }));
};
var $234eb071001a473c$export$2e2bcd8739ae039 = $234eb071001a473c$var$JiraAutomationAppWrapper;

});
parcelRegister("drk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c7e8d35da359c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aIZdc = parcelRequire("aIZdc");

var $4R6GH = parcelRequire("4R6GH");

var $9FUIO = parcelRequire("9FUIO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dZw8H = parcelRequire("dZw8H");

var $2tT7R = parcelRequire("2tT7R");

var $9OXo1 = parcelRequire("9OXo1");

var $7FRCI = parcelRequire("7FRCI");

var $fkREl = parcelRequire("fkREl");
const $c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME = 'automationManagerBootstrap.pack.js';
let $c8c7e8d35da359c5$var$isBootStrapBeenAppended = false;
const $c8c7e8d35da359c5$export$1d6aa6cfe656cb32 = (jiraEnvironment, isAutomationDevInstance)=>{
    if (isAutomationDevInstance) {
        if (jiraEnvironment === 'staging') return 'dev';
        if (jiraEnvironment === 'prod') return 'test';
    }
    return jiraEnvironment === 'staging' ? 'staging' : 'prod';
};
/**
 * https://developer.atlassian.com/platform/bifrost/config/custom-domain/#custom-domain:-stating-your-own-identity
 * For fedramp, we return **environment type** rather than the **environment** itself.
 * @param environment
 * @param isFedRampInstance
 * @returns
 */ const $c8c7e8d35da359c5$var$getBifrostEnvironment = (environment, isFedRampInstance = false)=>{
    let bifrostEnvironment;
    if (environment === 'staging') bifrostEnvironment = isFedRampInstance ? 'stg' : 'stg-east';
    else // it's empty for fedramp prod
    bifrostEnvironment = isFedRampInstance ? '' : 'prod-east';
    return bifrostEnvironment;
};
/**
 * Gets the correct Bifrost url suffix based on the perimeter
 */ const $c8c7e8d35da359c5$var$getBifrostUrlSuffix = (isFedRampInstance)=>isFedRampInstance ? 'frontend.cdn.atlassian-us-gov-mod.com' : 'frontend.public.atl-paas.net';
const $c8c7e8d35da359c5$var$generateBifrostBootstrapUrl = (env, buildNumber)=>{
    const isFedRampInstance = (0, $aIZdc.isFedRamp)();
    const bifrostUrlPrefix = 'https://automation-frontend';
    const bifrostEnvironment = $c8c7e8d35da359c5$var$getBifrostEnvironment(env, isFedRampInstance);
    const bifrostUrlSuffix = $c8c7e8d35da359c5$var$getBifrostUrlSuffix(isFedRampInstance);
    const bifrostBaseUrl = [
        bifrostUrlPrefix,
        bifrostEnvironment,
        bifrostUrlSuffix
    ]// remove empty strings
    .filter((str)=>str).join('.');
    const bifrostUrl = [
        bifrostBaseUrl,
        'assets',
        buildNumber,
        'bootstrap',
        $c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME
    ].join('/');
    return bifrostUrl;
};
const $c8c7e8d35da359c5$export$d08bde130a2fd8bc = (env, buildNumber)=>{
    // Local dev source
    if (env === 'dev') return `https://localhost:8082/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
    return $c8c7e8d35da359c5$var$generateBifrostBootstrapUrl(env, buildNumber);
};
const $c8c7e8d35da359c5$var$getBifrostBaseUrl = (env, perimeter)=>{
    const isFedRampInstance = perimeter === 'FEDRAMP';
    const bifrostUrlPrefix = 'https://automation-frontend';
    const bifrostEnvironment = $c8c7e8d35da359c5$var$getBifrostEnvironment(env, isFedRampInstance);
    const bifrostUrlSuffix = $c8c7e8d35da359c5$var$getBifrostUrlSuffix(isFedRampInstance);
    return [
        bifrostUrlPrefix,
        bifrostEnvironment,
        bifrostUrlSuffix
    ]// remove empty strings
    .filter((str)=>str).join('.');
};
const $c8c7e8d35da359c5$export$4bfd551f705b2cb = (env, perimeter)=>{
    // Local dev source
    if (env === 'dev') return `https://localhost:8082/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
    return `${$c8c7e8d35da359c5$var$getBifrostBaseUrl(env, perimeter)}/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
};
const $c8c7e8d35da359c5$var$AutomationAppStackContextLoader = ({ container: container })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const jiraEnvironment = (0, $2tT7R.useEnvironment)();
    const automationEnvironment = $c8c7e8d35da359c5$export$1d6aa6cfe656cb32(jiraEnvironment, (0, $4R6GH.fg)('automation-dev-helper'));
    (0, $5uXOq.useEffect)(()=>{
        if (performance) performance.mark('automation-host-product-start');
    }, []);
    const stackContext = (0, $fkREl.default)(cloudId, automationEnvironment);
    if (stackContext.status === 'loading') // TODO: consider a better loading state, it's non-trivial as our bootstrap script also adds a loader and deletes it
    return null;
    if (stackContext.status === 'error') return(// TODO: i18n and analytics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: stackContext.error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppBody, {
        automationEnvironment: automationEnvironment,
        activationId: activationId,
        cloudId: cloudId,
        stackContext: stackContext.value,
        container: container
    });
};
const $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE = 'Sorry, something went wrong loading Automation. Please try again.';
const $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE = 'Are you running devWatch?';
const $c8c7e8d35da359c5$var$AutomationAppBody = ({ automationEnvironment: automationEnvironment, activationId: activationId, cloudId: cloudId, stackContext: stackContext, container: container })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [bootStrapError, setBootStrapError] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c8c7e8d35da359c5$var$isBootStrapBeenAppended) {
            // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
            const script = document.createElement('script');
            const src = $c8c7e8d35da359c5$export$d08bde130a2fd8bc(automationEnvironment, stackContext.buildNumber);
            const startTime = performance.now();
            script.src = src;
            script.async = true;
            script.onload = ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'loaded'
                }), 'automationBootstrapFile loaded', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
            };
            script.onerror = async ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'failed'
                }), 'automationBootstrapFile failed', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
                setBootStrapError(automationEnvironment === 'dev' ? $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE : $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE);
                throw new Error(`Failed to load automation boostrap for env ${automationEnvironment}, src was '${src}'`);
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.appendChild(script);
            $c8c7e8d35da359c5$var$isBootStrapBeenAppended = true;
        }
    }, [
        automationEnvironment,
        createAnalyticsEvent,
        stackContext.buildNumber
    ]);
    // Lifecycle events automation application can respond to start the application, and destroy it.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.postMessage('automation-container-mounted');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.postMessage('automation-container-unmounted');
        };
    }, []);
    if (bootStrapError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: bootStrapError
    });
    const context = {
        activationId: activationId,
        cloudId: cloudId,
        scopeId: container?.id || 'GLOBAL',
        scopeKey: container?.key,
        scopeType: container?.type,
        productType: 'jira',
        env: automationEnvironment,
        staticPrefix: stackContext.staticPrefix,
        perimeter: stackContext.perimeter
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FUIO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "automation-container",
        "data-context": JSON.stringify(context),
        "data-testid": "automation.automation-app-container"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
const $c8c7e8d35da359c5$var$determineAutomationPerimeter = ()=>{
    if ((0, $aIZdc.isFedRamp)()) return 'FEDRAMP';
    return 'COMMERCIAL';
};
const $c8c7e8d35da359c5$var$AutomationAppComponent = ({ container: container })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const jiraEnvironment = (0, $2tT7R.useEnvironment)();
    const automationEnvironment = $c8c7e8d35da359c5$export$1d6aa6cfe656cb32(jiraEnvironment, (0, $4R6GH.fg)('automation-dev-helper'));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [bootStrapError, setBootStrapError] = (0, $5uXOq.useState)(null);
    const perimeter = (0, $5uXOq.useMemo)(()=>$c8c7e8d35da359c5$var$determineAutomationPerimeter(), []);
    (0, $5uXOq.useEffect)(()=>{
        if (performance) performance.mark('automation-host-product-start');
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c8c7e8d35da359c5$var$isBootStrapBeenAppended) {
            // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
            const script = document.createElement('script');
            const src = $c8c7e8d35da359c5$export$4bfd551f705b2cb(automationEnvironment, perimeter);
            const startTime = performance.now();
            script.src = src;
            script.async = true;
            script.onload = ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'loaded'
                }), 'automationBootstrapFile loaded', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
            };
            script.onerror = async ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'failed'
                }), 'automationBootstrapFile failed', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
                setBootStrapError(automationEnvironment === 'dev' ? $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE : $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE);
                throw new Error(`Failed to load automation boostrap for env ${automationEnvironment}, src was '${src}'`);
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.appendChild(script);
            $c8c7e8d35da359c5$var$isBootStrapBeenAppended = true;
        }
    }, [
        automationEnvironment,
        createAnalyticsEvent,
        perimeter
    ]);
    // Lifecycle events automation application can respond to start the application, and destroy it.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.postMessage('automation-container-mounted');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.postMessage('automation-container-unmounted');
        };
    }, []);
    if (bootStrapError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: bootStrapError
    });
    const context = {
        activationId: activationId,
        cloudId: cloudId,
        scopeId: container?.id || 'GLOBAL',
        scopeKey: container?.key,
        scopeType: container?.type,
        productType: 'jira',
        env: automationEnvironment,
        staticPrefix: $c8c7e8d35da359c5$var$getBifrostBaseUrl(automationEnvironment, perimeter),
        perimeter: perimeter,
        isUsingVersionedAssets: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FUIO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "automation-container",
        "data-context": JSON.stringify(context),
        "data-testid": "automation.automation-app-container"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
const $c8c7e8d35da359c5$var$AutomationApp = ({ container: container })=>{
    return (0, $4R6GH.fg)('jira_frontend_automation_versioned_assets') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppComponent, {
        container: container
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppStackContextLoader, {
        container: container
    });
};
var $c8c7e8d35da359c5$export$2e2bcd8739ae039 = $c8c7e8d35da359c5$var$AutomationApp;

});
parcelRegister("9FUIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1259b4dcb355d8f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener = (0, $kxZPA.lazy)(()=>(parcelRequire("hJNTj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $1259b4dcb355d8f8$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener, null)));
var $1259b4dcb355d8f8$export$2e2bcd8739ae039 = $1259b4dcb355d8f8$export$9b28d5c0f56030a7;

});
parcelRegister("hJNTj", function(module, exports) {

let $ce9d56fd530afe51$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ce9d56fd530afe51$var$load("hPzOn"),
    $ce9d56fd530afe51$var$load("eNmuD"),
    $ce9d56fd530afe51$var$load("h2MrD"),
    $ce9d56fd530afe51$var$load("bYT2S"),
    $ce9d56fd530afe51$var$load("cM9em"),
    $ce9d56fd530afe51$var$load("fr9NE"),
    $ce9d56fd530afe51$var$load("li0NF")
]).then(()=>parcelRequire('LS48m'));

});


parcelRegister("7FRCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e338e454c92b953e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");
const $e338e454c92b953e$var$BootstrapPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e338e454c92b953e$var$pageContainerStyles,
        testId: "automation.automation-platform-bootstrap-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e338e454c92b953e$var$contentContainerStyles
    }, props.children));
const $e338e454c92b953e$var$BootstrapError = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e338e454c92b953e$var$BootstrapPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        title: props.title
    }, props.description));
var $e338e454c92b953e$export$2e2bcd8739ae039 = $e338e454c92b953e$var$BootstrapError;
const $e338e454c92b953e$var$pageContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
});
const $e338e454c92b953e$var$contentContainerStyles = (0, $8CUq3.xcss)({
    justifyContent: 'center',
    width: '500px'
});

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$containerStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $a97355a0cc6aeb06$var$bleedStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $a97355a0cc6aeb06$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: 'font.body'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        // props for new icon
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $5uXOq = parcelRequire("5uXOq");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $eJS47 = parcelRequire("eJS47");

var $gtreQ = parcelRequire("gtreQ");

const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';




parcelRegister("fkREl", function(module, exports) {

$parcel$export(module.exports, "default", () => $572b5e2beda00d24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8JCZd = parcelRequire("8JCZd");
/**
 * dev and test don't have the best solutions.
 * test - on the first pass, it actually gets prod since the persistedStackId will be undefined.
 *        it then reaches the prod bootstrap logic which sets the testStackId and reloads
 * dev - it shouldn't come here, it will go to localhost first. this means the fallback is not yet supported.
 * @param bootstrapEnv
 * @returns
 */ const $572b5e2beda00d24$var$getApiPath = (bootstrapEnv)=>{
    if (bootstrapEnv === 'staging') return 'staging';
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const persistedTestStackId = window.sessionStorage.getItem('AUTOMATION_TEST_STACK_ID');
    if (bootstrapEnv === 'test' && typeof persistedTestStackId === 'string') return persistedTestStackId;
    return 'pro';
};
const $572b5e2beda00d24$var$getStackContextUrl = (cloudId, bootstrapEnv)=>`/gateway/api/automation/internal-api/jira/${cloudId}/${$572b5e2beda00d24$var$getApiPath(bootstrapEnv)}/rest/stackcontext`;
const $572b5e2beda00d24$var$DEV_STACK_CONTEXT = {
    // buildNumber is not actually used in dev since we don't redirect to bifrost, we serve from localhost
    buildNumber: 'automation-dev',
    staticPrefix: 'https://localhost:8088',
    perimeter: 'COMMERCIAL'
};
const $572b5e2beda00d24$var$useStackContext = (cloudId, bootstrapEnv)=>{
    const [stackContextResult, setStackContextResult] = (0, $5uXOq.useState)({
        status: 'loading',
        value: null,
        error: null
    });
    (0, $5uXOq.useEffect)(()=>{
        const abortController = new AbortController();
        const fetchStackContext = async ()=>{
            try {
                const response = await fetch($572b5e2beda00d24$var$getStackContextUrl(cloudId, bootstrapEnv), {
                    signal: abortController.signal
                });
                const data = await response.json();
                if (!(0, $8JCZd.isObjectStackContext)(data)) throw new Error('Something went wrong loading Automation');
                setStackContextResult({
                    status: 'success',
                    value: data,
                    error: null
                });
            } catch (e) {
                if (e instanceof Error) {
                    // no need to set error if it was aborted due to clean up
                    if (e.name === 'AbortError') return;
                    setStackContextResult({
                        status: 'error',
                        value: null,
                        error: e.message
                    });
                } else setStackContextResult({
                    status: 'error',
                    value: null,
                    error: String(e)
                });
            }
        };
        if (bootstrapEnv !== 'dev') fetchStackContext();
        return ()=>{
            abortController.abort();
        };
    }, [
        cloudId,
        bootstrapEnv
    ]);
    if (bootstrapEnv === 'dev') return {
        status: 'success',
        error: null,
        value: $572b5e2beda00d24$var$DEV_STACK_CONTEXT
    };
    return stackContextResult;
};
var $572b5e2beda00d24$export$2e2bcd8739ae039 = $572b5e2beda00d24$var$useStackContext;

});
parcelRegister("8JCZd", function(module, exports) {

$parcel$export(module.exports, "isObjectStackContext", () => $3613c469ecd988e9$export$f2c8b2575b518327);
const $3613c469ecd988e9$var$SUPPORTED_PERIMETERS = [
    'COMMERCIAL',
    'FEDRAMP'
];
const $3613c469ecd988e9$export$f2c8b2575b518327 = (value)=>{
    if (typeof value !== 'object' || value === null) return false;
    // ignore @typescript-eslint/consistent-type-assertions because we are checking the type of the object
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const potentialStackContext = value;
    return typeof potentialStackContext.staticPrefix === 'string' && typeof potentialStackContext.buildNumber === 'string' && $3613c469ecd988e9$var$SUPPORTED_PERIMETERS.includes(potentialStackContext.perimeter);
};

});



parcelRegister("Uj4ce", function(module, exports) {

$parcel$export(module.exports, "useNavigationAutomationLegacyEnabledResource", () => $c645a2088e7fdbff$export$ca7c07083e4556cd);

var $kJQXA = parcelRequire("kJQXA");

var $2YP9W = parcelRequire("2YP9W");
const $c645a2088e7fdbff$export$ca7c07083e4556cd = ()=>{
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource));
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("63MBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $97cfc99e6031092f$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.36.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $e0Brz = parcelRequire("e0Brz");

var $jS4lj = parcelRequire("jS4lj");

var $e0tCO = parcelRequire("e0tCO");

var $gEFwt = parcelRequire("gEFwt");

var $dAfqg = parcelRequire("dAfqg");
const $97cfc99e6031092f$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0Brz.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0tCO.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $97cfc99e6031092f$export$2e2bcd8739ae039 = $97cfc99e6031092f$var$AppContainer;
const $97cfc99e6031092f$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97cfc99e6031092f$var$NormalWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _ca0qze3t _u5f31ejb _n3tdze3t _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $97cfc99e6031092f$var$FullHeightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $97cfc99e6031092f$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1ejb _4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $97cfc99e6031092f$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ephoW.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itnZ9.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
    cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
    compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});


parcelRegister("e0tCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $67a65658db3ebd27$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $7Xr7M = parcelRequire("7Xr7M");
var $67a65658db3ebd27$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $7Xr7M.default));

});
parcelRegister("7Xr7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c779f1fa7b01b6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");

var $9zgyl = parcelRequire("9zgyl");
const $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: (0, $81ps3.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $9zgyl.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $14c779f1fa7b01b6$export$2e2bcd8739ae039 = $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb;

});
parcelRegister("9zgyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e487ef6161e77fc4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e487ef6161e77fc4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("huDMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa1a141fe516da1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa1a141fe516da1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    breadcrumb: {
        "id": "spa-apps.project-settings.jira-automation.breadcrumb",
        "defaultMessage": "Automation"
    }
});

});





//# sourceMappingURL=async-project-settings-jira-automation.72fc128c.js.map
